<template>
  <b-modal id="bv-modal-create-monitor" size="lg" hide-footer centered>
    <template v-slot:modal-title>
      Create Monitor
    </template>
    <b-form @submit.prevent="createMonitor">

      <b-form-group
        id="monitor-name-group"
        label="Topic monitor"
        label-for="monitor-name"
      >
        <b-form-input
          id="monitor-name"
          v-model="createForm.name"
          type="text"
          required
          placeholder="Enter a name"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="monitor-image-group"
        label="Image"
        label-for="monitor-image"
      >
        <b-form-file
          id="monitor-image"
          v-model="createForm.image"
          placeholder="Choose an image or drop it here..."
          ref="monitorImage"
          required
          @change="onFileChange"
        ></b-form-file>
      </b-form-group>

      <b-row v-if="uploadedImageUrl" class="mb-3">
        <b-col cols="12" sm="6">
          <img :src="uploadedImageUrl" class="img-fluid" />
        </b-col>
      </b-row>

      <b-row class="justify-content-end mb-4">
        <b-col cols="auto">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-language-group"
              label="Language"
              label-for="monitor-language"
              v-if="monitorLanguages.length"
            >
              <b-form-radio-group
                id="monitor-language"
                v-model="createForm.language"
                :options="monitorLanguages"
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
        <b-col cols="auto">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-group"
              :label="tagsLabel"
              label-for="monitor-tags"
              v-if="tagsCheckboxes.length"
            >
              <b-form-checkbox-group
                id="monitor-tags"
                v-model="createForm.tags"
                :options="tagsCheckboxes"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-alert
        :variant="alert.type"
        dismissible
        fade
        :show="alert.show"
        @dismissed="alert.show=0"
        @dismiss-count-down="alertCountDownChanged"
      >
        {{ alert.content }}
      </b-alert>

      <div class="text-right">
        <b-button type="submit" variant="primary">Create</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

import {
  MONITOR_CREATE,
  MONITOR_GET_LIST_CONSUMER,
  MONITOR_GET_LIST_MARKET
} from "@/store/actions.type";

export default {
  name: 'MonitorCreate',
  props: ['category', 'tagId'],
  data() {
    return {
      tagsCheckboxes: [],
      createForm: {
        name: '',
        image: null,
        language: '',
        tags: [],
      },
      monitorLanguages: [
        {
          text: 'Italian',
          value: '1'
        },
        {
          text: 'English',
          value: '2'
        }
      ],
      uploadedImageUrl: null,
      alert: {
        show: 0,
        type: '',
        content: ''
      }
    }
  },
  computed: {
    ...mapGetters(["monitorConsumerGenerations", "monitorMarketSectors"]),
    tagsLabel: function() {
      let tagsLabel = '';
      if(this.category == 'consumer') {
        tagsLabel = 'Consumer';
      }
      if(this.category == 'market') {
        tagsLabel = 'Market';
      }
      return tagsLabel
    }
  },
  methods: {
    alertCountDownChanged(dismissCountDown) {
      this.alert.show = dismissCountDown
    },
    generateTagsOptions() {       
      this.tagsCheckboxes = [];
      let rawTags = [];
      if(this.category == 'consumer') {
        rawTags = this.monitorConsumerGenerations;
        for (var i = 0; i < rawTags.length; i++) {
          let singleTag = {
            text: rawTags[i].generation,
            value: rawTags[i].id
          }
          this.tagsCheckboxes.push(singleTag);
        }
      }
      if(this.category == 'market') {
        rawTags = this.monitorMarketSectors;
        for (var j = 0; j < rawTags.length; j++) {
          let singleTag = {
            text: rawTags[j].sector,
            value: rawTags[j].id
          }
          this.tagsCheckboxes.push(singleTag);
        }
      }   
    },
    createMonitor() {

      if(!this.validateMonitorData()) {
        return
      }

      let monitorData = new FormData();
      monitorData.set('language', this.createForm.language);
      monitorData.set('name', this.createForm.name);
      monitorData.set('picture', this.createForm.image);
      for (var i = 0; i < this.createForm.tags.length; i++) {
        if(this.category == 'consumer') {
          monitorData.append('generations', this.createForm.tags[i]);
        }
        if(this.category == 'market') {
          monitorData.append('sectors', this.createForm.tags[i]);
        }
      }

      let payload = {
        category: this.category,
        monitor: monitorData
      }

      this.$store.dispatch(MONITOR_CREATE, payload).then(() => {
        this.$bvModal.hide('bv-modal-create-monitor');
        this.$bvToast.toast(`Monitor ${this.createForm.name} has been created successfully`, {
          title: 'Monitor created',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        if(this.category == 'consumer') {
          this.$store.dispatch(MONITOR_GET_LIST_CONSUMER);
        }
        if(this.category == 'market') {
          this.$store.dispatch(MONITOR_GET_LIST_MARKET);
        }
        this.resetForm();
      });
    },
    validateMonitorData() {
      if(!this.createForm.language && this.createForm.length != 0) {
        this.alert.show = 3;
        this.alert.type = 'danger';
        this.alert.content = 'You must select the language and at least one tag.';
        return false
      } else {
        return true
      }
    },
    resetForm() {
      this.createForm.name = '';
      this.createForm.image = null;
      this.uploadedImageUrl = '';
      this.createForm.language = '';
      this.createForm.tags = [];
      this.createForm.tags.push(this.tagId);
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.uploadedImageUrl = URL.createObjectURL(file);
    }
  },
  mounted() {
    this.generateTagsOptions();
  },
  watch: { 
    category: function() {
      this.generateTagsOptions();
    },
    tagId: function(value) {
      this.createForm.tags = [];
      this.createForm.tags.push(value);
    }
  }
}
</script>

<style lang="scss">
.monitor-tags-group {
  border: 1px solid $color-abbey;
  padding: rem(16px);
  border-radius: rem(8px);
  font-size: rem(14px);
  font-weight: 600;

  .form-group {
    margin-bottom: 0;
    
    > label {
      font-weight: 600;
      margin-bottom: rem(16px);
      color: $color-sunset;
      text-transform: uppercase;
      font-size: rem(14px);
    }
  }

  .custom-radio,
  .custom-checkbox {
    display: block;

    &:not(:last-child) {
      margin-bottom: rem(5px);
    }
  }

  #monitor-tags {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
